module.exports = __webpack_public_path__ + "static/media/icon-assigned.3bdcb4f2.svg";